import { render } from "./vk-icon.vue?vue&type=template&id=c1ffecb2"
import script from "./vk-icon.vue?vue&type=script&lang=js"
export * from "./vk-icon.vue?vue&type=script&lang=js"

import "./vk-icon.vue?vue&type=style&index=0&id=c1ffecb2&lang=css"
script.render = render

export default script